import { call, takeEvery } from 'redux-saga/effects';
import {
  DoRequestResponse,
  GlobalActions,
  GlobalPut,
  HTTP_METHOD,
} from '@ps20-frontend/shop-integration-redux';
import { FeatureToggleResponseModel } from '@ps20/bff-models';
import { App, FeatureToggles } from '@ps20-frontend/frontend-models';
import { safeSaga } from '@ps20-frontend/safe-saga';

export enum FEATURE_TOGGLE_REQUESTED_EVENTS {
  FEATURE_TOGGLE_REQUESTED_SUCCESSFUL = 'FEATURE_TOGGLE_REQUESTED_SUCCESSFUL',
  FEATURE_TOGGLE_REQUESTED_FAILED = 'FEATURE_TOGGLE_REQUESTED_FAILED',
}

export function* watchFeatureToggleRequestedEvent() {
  yield takeEvery(GlobalActions.AUTHENTICATION_SUCCESSFUL, safeSaga(callFeatureToggle, App.SHOP));
  yield takeEvery(
    FEATURE_TOGGLE_REQUESTED_EVENTS.FEATURE_TOGGLE_REQUESTED_SUCCESSFUL,
    safeSaga(successCallback, App.SHOP),
  );
}

function* getFeatureToogles() {
  const globalPut = GlobalPut.getInstance();
  yield call(
    [globalPut, globalPut.put],
    new GlobalActions().doRequest({
      appId: App.SHOP,
      url: 'privatschutz/api/featuretoggles',
      method: HTTP_METHOD.GET,
      successEvent: FEATURE_TOGGLE_REQUESTED_EVENTS.FEATURE_TOGGLE_REQUESTED_SUCCESSFUL,
      errorEvent: FEATURE_TOGGLE_REQUESTED_EVENTS.FEATURE_TOGGLE_REQUESTED_FAILED,
    }),
  );
}

export function* callFeatureToggle() {
  yield* getFeatureToogles();
}

export function* successCallback(successAction: DoRequestResponse<FeatureToggleResponseModel>) {
  const globalPut = GlobalPut.getInstance();

  const featureToggles: FeatureToggles = Object.keys(successAction.payload.toggles).reduce(
    (tempFeatureToggles: FeatureToggles, key) => {
      tempFeatureToggles[key] = successAction.payload.toggles[key];
      return tempFeatureToggles;
    },
    {},
  );

  yield call(globalPut.put, new GlobalActions().featuretoggleReceived(featureToggles));
}
